<template>
    <div>
        <Tabs v-model="activeIndex" type="card">
                    <TabPane label="用户详情" name="0"></TabPane>
                    <TabPane label="账号详情" name="1"></TabPane>
                    <TabPane label="付费记录" name="2"></TabPane>
                    <TabPane label="金币明细" name="3"></TabPane>
                    <TabPane label="已购剧集" name="4"></TabPane>
                </Tabs>
        <Card dis-hover>
            <div v-if="activeIndex==0">
                <User :userData="form"></User>
            </div>
            <div v-if="activeIndex==1">
                <Account :userData="account"></Account>
            </div>
            <div v-if="activeIndex==2">
                <payRecord :userData="{userId: userData.userId,id:form.id,colorationType:userData.colorationType}" :wallet="wallet"></payRecord>
            </div>
            <div v-if="activeIndex==3">
                <goldRecord :userData="{userId: userData.userId,id:form.id}" :wallet="wallet"></goldRecord>
            </div>
            <div v-if="activeIndex==4">
                <payedMovie :userData="{userId: userData.userId,id:form.id}"></payedMovie>
            </div>
        </Card>
    </div>
</template>

<script>
import User from './user'
import Account from './account'
import payRecord from './payRecord'
import goldRecord from './goldRecord'
import payedMovie from './payedMovie'
import { getUserInfo, getUserAccountInfo, getUserPayWalletList } from '@/api/user'
export default {
  components:{
    User,
    Account,
    payRecord,
    payedMovie,
    goldRecord
  },
  props:{
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeIndex: 0,
      form:{},
      wallet:{},
      account: {}
    }
  },
  methods:{
    async handleGetUser() {
      const { data } = await getUserInfo(this.userData.id)
      this.form = {...data,pid: this.userData.pid,linkId: this.userData.linkId}
      const { data:data1 } = await getUserAccountInfo(this.userData.id)
      this.account = data1
      const { data:data2 } = await getUserPayWalletList(this.userData.id)
      this.wallet = data2
    }
  },
  mounted() {
    this.handleGetUser()
  }
}
</script>

<style scoped lang="less">
/deep/.ivu-row{
    .ivu-form-item-label{
        font-size: 15px;
    }
    .ivu-form-item-content{
        font-size: 15px;
    }

}
/deep/.ivu-tabs-bar{
    margin: 0;
}
</style>
